module.exports = __webpack_public_path__ + "img/trade.48f1c9bb.png";